import CryptoJS from 'crypto-js'
/**
  *
  * 第一个参数word是待加密或者解密的字符串；
  * 第二个参数keyStr是aes加密需要用到的16位字符串的key；
  * 第三个参数是初始化向量 iv。
  */
export default {
  // 加密
  Encrypt(word, keyStr, ivStr) {
    keyStr = keyStr || 'hj7x89H$yuBI0456'
    ivStr = ivStr || 'NIfb&95GUY86Gfgh'
    const key = CryptoJS.enc.Utf8.parse(keyStr)
    const iv = CryptoJS.enc.Utf8.parse(ivStr)
    const srcs = CryptoJS.enc.Utf8.parse(word)

    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    })
    return encrypted.toString()
  },
  // 解密
  Decrypt(word, keyStr, ivStr) {
    keyStr = keyStr || 'hj7x89H$yuBI0456'
    ivStr = ivStr || 'NIfb&95GUY86Gfgh'
    var key = CryptoJS.enc.Utf8.parse(keyStr)
    const iv = CryptoJS.enc.Utf8.parse(ivStr)

    var decrypt = CryptoJS.AES.decrypt(word, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    })
    return decrypt.toString(CryptoJS.enc.Utf8)
  }
}
